// import * as mutation from '../mutations';
import axios from 'axios';
import withDecrypt from '../../src/withDecrypt';
// import decorators from '../../src/api/decorators';
// import requestService from '../../src/api/services/requestService';
// import { home } from '../../src/api/queries';
// import { doHomePageAction } from '../../src/actions';
// import { actionConstants } from '../../src/constants';

async function fetchAPI(query, { variables, preview } = {}) {
  return axios({
    method: 'post',
    url: process.env.NEXT_PUBLIC_API_URL,
    data: {
      query,
    },
    // headers: { 'accessToken': args[0] },
  })
    .then(resp => resp?.data?.errors ? resp?.data?.errors[0] : withDecrypt(resp.data))
    .catch(err => {
      console.log(err);
    });
}

export default async function _getWideScreenerMetrics(andor, formula, first, offset) {
  const removeQuotes = (str) => str.replace(/"/g, "");
  const objectToString = (obj) =>
    `{
    andor: ${removeQuotes(obj.andor)},
    metricsCriteria: [
      ${obj.metricsCriteria
      .map(
        (item) =>
          (item.code === `\`industry\`` || item.code === `\`sector\``) ?
            `{
            code: \"${item?.code?.replace(/`/g, '')}\",
            condition: ${removeQuotes(item.condition)},
            value: "\\"${item.value}\\""
          }`:
            `{
            code: "${item.code}",
            condition: ${removeQuotes(item.condition)},
            value: "${item.value}"
          }`
      )
      .join(",\n")}
    ]
  }`;
  const formulaString = `[${formula.map(objectToString).join(",\n")}]`;
  const data = await fetchAPI(
    `
    query {
      getWideScreenerMetricsV3(andor: ${andor}, exclude_bad: true, formula: ${formulaString}, first: ${first}, offset: ${offset}) {
        ticker
        tickername: name
        sector
        industry
        PCHG__7
        PCHG__30
        PCHG__180
        PCHG__365
        RETURNS__1095
        REV_TTM
        NETINC_TTM
        MKTCAP
        EBT
        REV_TTM__PCHG_1Y
        NETINC_TTM__PCHG_1Y
        REV_TTM__PCHG_3Y
        NETINC_TTM__PCHG_3Y
        SHR_OUTS__PCHG_1Y
        SHR_OUTS__PCHG_3Y
        PE
        PS
        PCF
        MKTEBT
        ROA
        ROE
        DIV_YIELD
        BUYBACK__PCHG_1Y
        DEBT_EQ
        EBT_MGN
        NETINC_MGN
        OPER_MGN
        DRAWDN_PROB30__5Y
        VOL__Y
        EBITDA_TTM
        FCF_TTM
        FCF_PS_TTM
        FCF_YIELD
        ASSETS
        LIABS
        SEQ
        RETEARN
        RETEARN__PCHG_1Y
        RETEARN__PCHG_3Y
        EV_EBITDA
        PFCF
        EBITDA_MGN
        CFINV
        CFINV_TTM
        CFOPER
        CFOPER_TTM
        CFFIN
        CFFIN_TTM
        CASHEQ
        CR
        ASSETS__PCHG_1Y
        ASS_SAL
        DEBT_LT
        DIV_PS_TTM
        DRAWDN
        EPS
        EPS_TTM
        INT_COV
        INT_CFOPER
        RETURNS__1825
        RISKLEVEL__5Y
        ITXR
        COSTREV
        IMP_ASSETS
        INVWD
        SHRCOMP_TTM
        EV
        REV__PCHG_1Y
        NETINC__PCHG_1Y
        EBIT_TTM
        EBIT_TTM__PCHG_1Y
        EBIT_TTM__PCHG_3Y
        SAL_INV
        RETURNS__3650
        RETURNS__2555
        PPE_NET
        OPEX_TTM
        ASSETS_CUR
        LIABS_CUR
        INVY
        INSTPCT
        GWILL
        IMP_GWILL
        DEBT_RAT
        DEPAMOR_TTM
        PROFIT_GROSS_TTM
        PROFIT_OPER_TTM
      }
    }
    `
  )
  return data
}


// // import * as mutation from '../mutations';
// import axios from 'axios';
// import withDecrypt from '../../src/withDecrypt';
// // import decorators from '../../src/api/decorators';
// // import requestService from '../../src/api/services/requestService';
// // import { home } from '../../src/api/queries';
// // import { doHomePageAction } from '../../src/actions';
// // import { actionConstants } from '../../src/constants';

// async function fetchAPI(query, { variables, preview } = {}) {
//   return axios({
//     method: 'post',
//     url: process.env.NEXT_PUBLIC_API_URL,
//     data: {
//       query,
//     },
//     // headers: { 'accessToken': args[0] },
//   })
//     .then(resp => withDecrypt(resp.data))
//     .catch(err => {
//       console.log(err);
//     });
// }

// export default async function _getWideScreenerMetrics(mktCapCat, conditions, first, offset) {
//   const data = await fetchAPI(
//     `
//     query {
//         getWideScreenerMetrics(metricsCriteria:[${conditions && conditions?.map(d => `{ code:"${d.code}", condition: ${d.condition}, value: ${d.value}, tovalue: ${d.tovalue || null}}`)}], mktCapCat: ${mktCapCat}, first: ${first}, offset: ${offset}) {
//             ticker
//             tickername: name
//             PCHG__7
//             PCHG__30
//             PCHG__180
//             PCHG__365
//             RETURNS__1095
//             REV_TTM
//             NETINC_TTM
//             MKTCAP
//             EBT
//             REV_TTM__PCHG_1Y
//             NETINC_TTM__PCHG_1Y
//             REV_TTM__PCHG_3Y
//             NETINC_TTM__PCHG_3Y
//             SHR_OUTS__PCHG_1Y
//             SHR_OUTS__PCHG_3Y
//             PE
//             PS
//             PCF
//             MKTEBT
//             ROA
//             ROE
//             DIV_YIELD
//             BUYBACK__PCHG_1Y
//             DEBT_EQ
//             EBT_MGN
//             NETINC_MGN
//             OPER_MGN
//             DRAWDN_PROB30__5Y
//             VOL__Y
//         }
//     }
//     `
//   )
//   return data
// }
